import { render, staticRenderFns } from "./bp-submit.vue?vue&type=template&id=07c9dcd3&"
import script from "./bp-submit.vue?vue&type=script&lang=ts&"
export * from "./bp-submit.vue?vue&type=script&lang=ts&"
import style0 from "./bp-submit.vue?vue&type=style&index=0&id=07c9dcd3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports